import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'TNAPeriod',
  data() {
    return {
      periodForm: {
        startDate: '',
        endDate: ''
      },
      isAdd: false,
      isEditMode: false,
      editingPeriod: null,
      isDisStartDate: false,
      // Pagination local state
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      columns: [
        {
          label: 'No',
          field: 'no',
          type: 'number',
          width: '80px',
          tdClass: 'text-center',
          sortable: false
        },
        {
          label: 'Period',
          field: 'period',
          width: '250px'
        },
        {
          label: 'Start Date',
          field: 'start_date'
        },
        {
          label: 'End Date',
          field: 'end_date'
        },
        {
          label: 'Status',
          field: 'status',
          width: '120px'
        },
        {
          label: 'Actions',
          field: 'action',
          width: '100px',
          tdClass: 'text-center',
          sortable: false
        }
      ]
    };
  },
  computed: {
    ...mapGetters('tnaPeriod', {
      periods: 'periods',
      isLoading: 'loading',
      error: 'error',
      totalItems: 'getTotalItems',
      totalPages: 'getTotalPages'
    })
  },
  methods: {
    ...mapActions('tnaPeriod', [
      'getTNAPeriods',
      'createTNAPeriod',
      'updateTNAPeriod'
    ]),

    async fetchPeriods() {
      try {
        await this.getTNAPeriods({
          page: this.currentPage,
          limit: this.perPage
        });
      } catch (error) {
        console.error('Error fetching TNA periods:', error);
        this.$swal('Error', 'Periode TNA belum berhasil dimuat', 'error');
      }
    },
    
    // Vue Good Table pagination event handlers
    onPageChange(params) {
      this.currentPage = params.currentPage;
      this.fetchPeriods();
    },
    
    onPerPageChangeVGT(params) {
      this.perPage = params.currentPerPage;
      this.currentPage = 1; // Reset to first page
      this.fetchPeriods();
    },

    openAddModal() {
      this.isEditMode = false;
      this.editingPeriod = null;
      this.setTodayDate();
      this.isDisStartDate = false;
      this.isAdd = true;
    },

    openEditModal(period) {
      this.isEditMode = true;
      this.editingPeriod = period;
      this.periodForm = {
        startDate: this.$moment(period.start_date).format('YYYY-MM-DD'),
        endDate: this.$moment(period.end_date).format('YYYY-MM-DD')
      };
      if (period.status == 'open') {
        this.isDisStartDate = true;
      } else {
        this.isDisStartDate = false;
      }
      this.isAdd = true;
    },

    async savePeriod() {
      // Validation
      if (!this.periodForm.startDate || !this.periodForm.endDate) {
        this.$swal('Warning', 'Pilih tanggal mulai dan tanggal selesai', 'warning');
        return;
      }

      if (this.periodForm.startDate >= this.periodForm.endDate) {
        this.$swal('Warning', 'Tanggal selesai harus setelah tanggal mulai', 'warning');
        return;
      }

      try {
        const data = {
          start_date: this.periodForm.startDate,
          end_date: this.periodForm.endDate
        };

        if (this.isEditMode && this.editingPeriod) {
          // Update existing period
          await this.updateTNAPeriod({ id: this.editingPeriod.id, data });
          this.$swal({
            icon: 'success',
            title: 'Success',
            text: 'Periode TNA berhasil diperbarui'
          }).then(() => {
            this.isAdd = false;
            this.fetchPeriods();
            this.setTodayDate();
          });
        } else {
          // Create new period
          await this.createTNAPeriod(data);
          this.$swal({
            icon: 'success',
            title: 'Success',
            text: 'Periode TNA berhasil dibuat'
          }).then(() => {
            this.isAdd = false;
            this.fetchPeriods();
            this.setTodayDate();
          });
        }
      } catch (error) {
        console.error('Error saving TNA period:', error);
        this.$swal('Error', error.message || 'Periode TNA belum berhasil disimpan', 'error');
      }
    },

    formatDate(value) {
      if (!value) return 'Invalid date';
      const dateMoment = this.$moment(value);
      if (dateMoment.isValid()) {
        return dateMoment.format('DD-MM-YYYY');
      }
      return 'Invalid date';
    },

    setTodayDate() {
      const today = this.$moment(new Date()).format('YYYY-MM-DD');
      this.periodForm.startDate = today;
      this.periodForm.endDate = today;
    },

    getPeriodStatus(period) {
      const now = new Date();
      const start = new Date(period.start_date);
      const end = new Date(period.end_date);

      if (now > end) {
        return { class: 'badge-secondary' };
      } else {
        return { class: 'badge-success' };
      }
    }
  },
  mounted() {
    console.log('✅ TNA Period page mounted');
    this.fetchPeriods();
  }
};
